/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Zenith API
 * This site hosts documentation generated from the Zenith API OpenAPI specification.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  IdentityLoginRequest,
  IdentityLoginResponse,
  IdentityLogoutRequest,
  IdentityLogoutResponse,
  IdentityRefreshRequest,
  IdentityRefreshResponse,
  IdentityRegisterRequest,
  IdentityRegisterResponse,
  IdentityRequestPasswordResetRequest,
  IdentityRequestPasswordResetResponse,
  IdentityResetPasswordRequest,
  IdentityResetPasswordResponse,
  IdentityServiceGetUserParams,
  IdentityUpdateProfileRequest,
  IdentityUser,
  RpcStatus
} from '../model';

import { apiClient } from '../../lib/client';




/**
 * Logs in a user with the provided credentials.
 * @summary login
 */
export const identityServiceLogin = (
    identityLoginRequest: MaybeRefOrGetter<IdentityLoginRequest>,
 signal?: AbortSignal
) => {
      identityLoginRequest = toValue(identityLoginRequest);

      return apiClient<IdentityLoginResponse>(
      {url: `/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityLoginRequest, signal
    },
      );
    }




export const getIdentityServiceLoginMutationKey = () => ['identityServiceLogin'] as const;

export const getIdentityServiceLoginMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceLogin>>, TError,IdentityServiceLoginMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof identityServiceLogin>>, TError,IdentityServiceLoginMutationVariables, TContext> => {

const mutationKey = getIdentityServiceLoginMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityServiceLogin>>, IdentityServiceLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityServiceLogin(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityServiceLoginMutationResult = NonNullable<Awaited<ReturnType<typeof identityServiceLogin>>>
    export type IdentityServiceLoginMutationBody = IdentityLoginRequest
    export type IdentityServiceLoginMutationError = RpcStatus
    export type IdentityServiceLoginMutationVariables = {data: IdentityLoginRequest}

    /**
 * @summary login
 */
export const useIdentityServiceLogin = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceLogin>>, TError,IdentityServiceLoginMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof identityServiceLogin>>,
        TError,
        IdentityServiceLoginMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityServiceLoginMutationOptions(options), queryClient);
    }
    /**
 * Clears the session cookies.
 * @summary logout
 */
export const identityServiceLogout = (
    identityLogoutRequest: MaybeRefOrGetter<IdentityLogoutRequest>,
 signal?: AbortSignal
) => {
      identityLogoutRequest = toValue(identityLogoutRequest);

      return apiClient<IdentityLogoutResponse>(
      {url: `/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityLogoutRequest, signal
    },
      );
    }




export const getIdentityServiceLogoutMutationKey = () => ['identityServiceLogout'] as const;

export const getIdentityServiceLogoutMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceLogout>>, TError,IdentityServiceLogoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof identityServiceLogout>>, TError,IdentityServiceLogoutMutationVariables, TContext> => {

const mutationKey = getIdentityServiceLogoutMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityServiceLogout>>, IdentityServiceLogoutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityServiceLogout(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityServiceLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof identityServiceLogout>>>
    export type IdentityServiceLogoutMutationBody = IdentityLogoutRequest
    export type IdentityServiceLogoutMutationError = RpcStatus
    export type IdentityServiceLogoutMutationVariables = {data: IdentityLogoutRequest}

    /**
 * @summary logout
 */
export const useIdentityServiceLogout = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceLogout>>, TError,IdentityServiceLogoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof identityServiceLogout>>,
        TError,
        IdentityServiceLogoutMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityServiceLogoutMutationOptions(options), queryClient);
    }
    /**
 * @summary ResetPassword sets a new password using the provided reset token.
 */
export const identityServiceResetPassword = (
    identityResetPasswordRequest: MaybeRefOrGetter<IdentityResetPasswordRequest>,
 signal?: AbortSignal
) => {
      identityResetPasswordRequest = toValue(identityResetPasswordRequest);

      return apiClient<IdentityResetPasswordResponse>(
      {url: `/password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityResetPasswordRequest, signal
    },
      );
    }




export const getIdentityServiceResetPasswordMutationKey = () => ['identityServiceResetPassword'] as const;

export const getIdentityServiceResetPasswordMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceResetPassword>>, TError,IdentityServiceResetPasswordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof identityServiceResetPassword>>, TError,IdentityServiceResetPasswordMutationVariables, TContext> => {

const mutationKey = getIdentityServiceResetPasswordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityServiceResetPassword>>, IdentityServiceResetPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityServiceResetPassword(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityServiceResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof identityServiceResetPassword>>>
    export type IdentityServiceResetPasswordMutationBody = IdentityResetPasswordRequest
    export type IdentityServiceResetPasswordMutationError = RpcStatus
    export type IdentityServiceResetPasswordMutationVariables = {data: IdentityResetPasswordRequest}

    /**
 * @summary ResetPassword sets a new password using the provided reset token.
 */
export const useIdentityServiceResetPassword = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceResetPassword>>, TError,IdentityServiceResetPasswordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof identityServiceResetPassword>>,
        TError,
        IdentityServiceResetPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityServiceResetPasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary RequestPasswordReset sends a password reset email to the given address.
 */
export const identityServiceRequestPasswordReset = (
    identityRequestPasswordResetRequest: MaybeRefOrGetter<IdentityRequestPasswordResetRequest>,
 signal?: AbortSignal
) => {
      identityRequestPasswordResetRequest = toValue(identityRequestPasswordResetRequest);

      return apiClient<IdentityRequestPasswordResetResponse>(
      {url: `/password/reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityRequestPasswordResetRequest, signal
    },
      );
    }




export const getIdentityServiceRequestPasswordResetMutationKey = () => ['identityServiceRequestPasswordReset'] as const;

export const getIdentityServiceRequestPasswordResetMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceRequestPasswordReset>>, TError,IdentityServiceRequestPasswordResetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof identityServiceRequestPasswordReset>>, TError,IdentityServiceRequestPasswordResetMutationVariables, TContext> => {

const mutationKey = getIdentityServiceRequestPasswordResetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityServiceRequestPasswordReset>>, IdentityServiceRequestPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityServiceRequestPasswordReset(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityServiceRequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof identityServiceRequestPasswordReset>>>
    export type IdentityServiceRequestPasswordResetMutationBody = IdentityRequestPasswordResetRequest
    export type IdentityServiceRequestPasswordResetMutationError = RpcStatus
    export type IdentityServiceRequestPasswordResetMutationVariables = {data: IdentityRequestPasswordResetRequest}

    /**
 * @summary RequestPasswordReset sends a password reset email to the given address.
 */
export const useIdentityServiceRequestPasswordReset = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceRequestPasswordReset>>, TError,IdentityServiceRequestPasswordResetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof identityServiceRequestPasswordReset>>,
        TError,
        IdentityServiceRequestPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityServiceRequestPasswordResetMutationOptions(options), queryClient);
    }
    /**
 * Exchanges the refresh cookie for a new access token.
 * @summary refresh
 */
export const identityServiceRefresh = (
    identityRefreshRequest: MaybeRefOrGetter<IdentityRefreshRequest>,
 signal?: AbortSignal
) => {
      identityRefreshRequest = toValue(identityRefreshRequest);

      return apiClient<IdentityRefreshResponse>(
      {url: `/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityRefreshRequest, signal
    },
      );
    }




export const getIdentityServiceRefreshMutationKey = () => ['identityServiceRefresh'] as const;

export const getIdentityServiceRefreshMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceRefresh>>, TError,IdentityServiceRefreshMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof identityServiceRefresh>>, TError,IdentityServiceRefreshMutationVariables, TContext> => {

const mutationKey = getIdentityServiceRefreshMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityServiceRefresh>>, IdentityServiceRefreshMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityServiceRefresh(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityServiceRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof identityServiceRefresh>>>
    export type IdentityServiceRefreshMutationBody = IdentityRefreshRequest
    export type IdentityServiceRefreshMutationError = RpcStatus
    export type IdentityServiceRefreshMutationVariables = {data: IdentityRefreshRequest}

    /**
 * @summary refresh
 */
export const useIdentityServiceRefresh = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceRefresh>>, TError,IdentityServiceRefreshMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof identityServiceRefresh>>,
        TError,
        IdentityServiceRefreshMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityServiceRefreshMutationOptions(options), queryClient);
    }
    /**
 * @summary Register creates a new user account with the provided email.
The user is created in invited status; activation completes via ResetPassword.
 */
export const identityServiceRegister = (
    identityRegisterRequest: MaybeRefOrGetter<IdentityRegisterRequest>,
 signal?: AbortSignal
) => {
      identityRegisterRequest = toValue(identityRegisterRequest);

      return apiClient<IdentityRegisterResponse>(
      {url: `/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityRegisterRequest, signal
    },
      );
    }




export const getIdentityServiceRegisterMutationKey = () => ['identityServiceRegister'] as const;

export const getIdentityServiceRegisterMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceRegister>>, TError,IdentityServiceRegisterMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof identityServiceRegister>>, TError,IdentityServiceRegisterMutationVariables, TContext> => {

const mutationKey = getIdentityServiceRegisterMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityServiceRegister>>, IdentityServiceRegisterMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityServiceRegister(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityServiceRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof identityServiceRegister>>>
    export type IdentityServiceRegisterMutationBody = IdentityRegisterRequest
    export type IdentityServiceRegisterMutationError = RpcStatus
    export type IdentityServiceRegisterMutationVariables = {data: IdentityRegisterRequest}

    /**
 * @summary Register creates a new user account with the provided email.
The user is created in invited status; activation completes via ResetPassword.
 */
export const useIdentityServiceRegister = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceRegister>>, TError,IdentityServiceRegisterMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof identityServiceRegister>>,
        TError,
        IdentityServiceRegisterMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityServiceRegisterMutationOptions(options), queryClient);
    }
    /**
 * Retrieves the current user's profile information.
 * @summary GetUserInfo
 */
export const identityServiceGetUser = (
    params?: MaybeRefOrGetter<IdentityServiceGetUserParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return apiClient<IdentityUser>(
      {url: `/userinfo`, method: 'GET',
        params, signal
    },
      );
    }




export const getIdentityServiceGetUserQueryKey = (params?: MaybeRefOrGetter<IdentityServiceGetUserParams>,) => {
    return [
    'userinfo', ...(params ? [params] : [])
    ] as const;
    }


export const getIdentityServiceGetUserQueryOptions = <TData = Awaited<ReturnType<typeof identityServiceGetUser>>, TError = RpcStatus>(params?: MaybeRefOrGetter<IdentityServiceGetUserParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityServiceGetUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getIdentityServiceGetUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityServiceGetUser>>> = ({ signal }) => identityServiceGetUser(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityServiceGetUser>>, TError, TData>
}

export type IdentityServiceGetUserQueryResult = NonNullable<Awaited<ReturnType<typeof identityServiceGetUser>>>
export type IdentityServiceGetUserQueryError = RpcStatus


/**
 * @summary GetUserInfo
 */

export function useIdentityServiceGetUser<TData = Awaited<ReturnType<typeof identityServiceGetUser>>, TError = RpcStatus>(
 params?: MaybeRefOrGetter<IdentityServiceGetUserParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityServiceGetUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityServiceGetUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Updates the user's profile information like first and last name. Only provided fields will be updated.
 * @summary UpdateUserInfo
 */
export const identityServiceUpdateProfile = (
    identityUpdateProfileRequest: MaybeRefOrGetter<IdentityUpdateProfileRequest>,
 signal?: AbortSignal
) => {
      identityUpdateProfileRequest = toValue(identityUpdateProfileRequest);

      return apiClient<IdentityUser>(
      {url: `/userinfo`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: identityUpdateProfileRequest, signal
    },
      );
    }




export const getIdentityServiceUpdateProfileMutationKey = () => ['identityServiceUpdateProfile'] as const;

export const getIdentityServiceUpdateProfileMutationOptions = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceUpdateProfile>>, TError,IdentityServiceUpdateProfileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof identityServiceUpdateProfile>>, TError,IdentityServiceUpdateProfileMutationVariables, TContext> => {

const mutationKey = getIdentityServiceUpdateProfileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityServiceUpdateProfile>>, IdentityServiceUpdateProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityServiceUpdateProfile(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityServiceUpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof identityServiceUpdateProfile>>>
    export type IdentityServiceUpdateProfileMutationBody = IdentityUpdateProfileRequest
    export type IdentityServiceUpdateProfileMutationError = RpcStatus
    export type IdentityServiceUpdateProfileMutationVariables = {data: IdentityUpdateProfileRequest}

    /**
 * @summary UpdateUserInfo
 */
export const useIdentityServiceUpdateProfile = <TError = RpcStatus,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityServiceUpdateProfile>>, TError,IdentityServiceUpdateProfileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof identityServiceUpdateProfile>>,
        TError,
        IdentityServiceUpdateProfileMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityServiceUpdateProfileMutationOptions(options), queryClient);
    }
